import * as iso8601 from "iso8601-convert";
import moment, { Moment } from "moment-timezone";

function toStartDate(date: Moment) {
    const startDate = moment(date);
    startDate.set("hour", 0);
    startDate.set("minute", 0);
    startDate.set("second", 0);
    startDate.set("millisecond", 0);
    return startDate;
}

function toEndDate(date: Moment) {
    const endDate = moment(date);
    endDate.set("hour", 23);
    endDate.set("minute", 59);
    endDate.set("second", 59);
    endDate.set("millisecond", 999);
    return endDate;
}

function getDefaultEndDate(): moment.Moment {
    const endDate = toEndDate(moment());
    return endDate;
}

function getDefaultStartDate(endDate: moment.Moment): moment.Moment {
    const startDate = toStartDate(moment(endDate).subtract(1, "month"));
    return startDate;
}

function parseDate(unparsed: string): Date {
    return moment(iso8601.toDate(unparsed)).toDate();
}

/**
 * An interval of time.
 *
 * Note: requires that `start < end`.
 */
interface Interval {
    start: Moment;
    end: Moment;
}

/**
 * Determines if two intervals overlap in time.
 *
 * Two intervals overlap if the last interval starts before the first interval ends.
 *
 * @param a An interval
 * @param b An interval
 * @returns `true` if the intervals overlap, `false` otherwise.
 */
function intervalsOverlap(a: Interval, b: Interval): boolean {
    const maxStart = moment.max(a.start, b.start);
    const minEnd = moment.min(a.end, b.end);
    return !maxStart.isAfter(minEnd);
}

export {
    getDefaultStartDate,
    getDefaultEndDate,
    parseDate,
    type Interval,
    intervalsOverlap,
};
